import moment from 'moment'
import React, { useEffect, useState } from 'react'

const FormInputTanggal = ({ handleChangeDate, existingDisplayAt }) => {
  /* ======================================= Local States ======================================= */
  const [dateNow, setDateNow] = useState('')

  /* ========================================= Functions ======================================== */
  function getDateNow() {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const yyyy = today.getFullYear()

    setDateNow(`${yyyy}-${mm}-${dd}`)
  }

  function handleClearDate() {
    handleChangeDate({
      target: {
        value: ''
      }
    })
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getDateNow()
  }, [])

  /* ========================================== Output ========================================== */
  return (
    <div className="form-group mb-5 row">
      <label className="col-sm-3 col-form-label">
        Tanggal Mulai
      </label>

      <div className="col-sm-3 d-flex flex-row gap-2">
        <input
          key={`tanggal-input-${dateNow}-${existingDisplayAt || ''}`}
          style={{ width: '100%' }}
          type="datetime-local"
          min={dateNow}
          onChange={(event) => handleChangeDate(event)}
          value={
            existingDisplayAt
              ? moment(existingDisplayAt).format('YYYY-MM-DDTHH:mm')
              : ''
          }
          className="form-control"
        />

        <button
          type="button"
          onClick={handleClearDate}
          className="btn btn-outline-primary btn-sm w-100"
          style={{ marginLeft: 8 }}
        >
          Clear
        </button>
      </div>
    </div>
  )
}

export default FormInputTanggal